import api from '@/api'

const traceDataByTraceCode = {
  props: {
    // 通过绑定 route.query 传递
    traceCode: {
      type: String,
      default: undefined
    }
  },
  computed: {
    landId() {
      if (this.traceData.landId) {
        return this.traceData.landId
      }
      return this.$route.query.landId
    }
  },
  data() {
    return {
      traceData: {
        land: {}
      }
    }
  },
  watch: {
    traceCode: {
      async handler(newVal) {
        if (newVal) {
          await this.initTranceSource(newVal)
        }
      },
      immediate: true
    }
  },
  methods: {
    async initTranceSource(traceCode) {
      this.traceData = await api.getControlProductTrace({ traceCode: traceCode }).then(({ data }) => {
        return data
      })
    }
  }
}

export { traceDataByTraceCode }
